<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import axios from "axios";
import Autocomplete from "@trevoreyre/autocomplete-vue";
import "@trevoreyre/autocomplete-vue/dist/style.css";

export default {
  components: {
    Layout,
    PageHeader,
    Autocomplete,
  },
  page: {
    title: "List Paket Soal",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      title: "CBT - List Paket Soal",
      items: [
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: "Student",
          href: "/student",
        },
        {
          text: "List Paket Soal",
          active: true,
        },
      ],
      setDetailPaketSoal: null,
      setDataSearch: [],
    };
  },
  mounted() {
    this.getListlPaketSoal();
  },
  methods: {
    async getListlPaketSoal() {
      await axios
        .get(
          process.env.VUE_APP_API_BASE_URL +
            "/api/json/get-list-soal/" +
            this.$route.params.id
        )
        .then((response) => {
          response.data.forEach((data) => {
            this.setDataSearch.push(data.soal);
          });
          return (this.setDetailPaketSoal = response.data);
        })
        .catch(function(error) {
          // handle error
          console.log(error);
        });
    },
    search(input) {
      if (input.length < 0) {
        return [];
      }
      return this.setDataSearch.filter((a) => {
        return a.deskripsi.toLowerCase().startsWith(input.toLowerCase());
      });
    },
    getResultValue(result) {
      return result.deskripsi;
    },
    handleSubmit(result) {
      window.open(
        `${process.env.VUE_APP_BASE_URL}/student/ujian/detail/${encodeURI(
          result.id
        )}`
      );
    },
  },
};
</script>
<style scoped>
.card-body {
  /* background-color: var(--bs-purple); */
  background: rgb(19,0,38);
background: radial-gradient(circle, rgba(19,0,38,1) 0%, rgba(71,33,136,1) 63%, rgba(111,66,193,1) 100%);
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}
.card-body-custom {
  background: var(--bs-purple) !important;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}
.card-body > h6 {
  color: var(--bs-light);
  text-align: center;
  text-transform: uppercase;
}
.card:hover {
  transform: scale(1.1);
}
</style>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <h3>{{ setDetailPaketSoal && setDetailPaketSoal[0].paket_soal.name }}</h3>
    <div class="container-fluid mt-3 mb-3">
      <autocomplete
        :search="search"
        placeholder="Cari Deskripsi Paket Soal, 'Contoh: Tes kecermatan'"
        aria-label="Cari Deskripsi Paket Soal, 'Contoh: Tes kecermatan'"
        :get-result-value="getResultValue"
        @submit="handleSubmit"
        auto-select
      ></autocomplete>
    </div>
    <div class="container row">
      <div
        class="col-sm-6 col-lg-3 mt-3 mb-3"
        v-for="dataBody in setDetailPaketSoal"
        :key="dataBody.id"
      >
        <div v-if="dataBody.jawab === null || undefined">
          <b-link :href="'/student/ujian/detail/' + dataBody.id_soal">
            <b-card
              id="card"
              class="m-2"
              :img-src="require('@/assets/images/cbt/cover-course-v1.png')"
              img-alt="Card image"
              img-top
            >
              <h6>
                {{ dataBody.soal.deskripsi }}
              </h6>
              <h6 class="m-0" style="font-size: 13px;">
                {{ dataBody.length_soal }} SOAL ({{ dataBody.soal.waktu }}
                MENIT)
              </h6>
            </b-card>
          </b-link>
        </div>
        <div v-else>
          <b-link :href="'/scores'">
            <div class="card m-2">
              <img
                src="@/assets/images/cbt/cover-course-v1.png"
                class="card-img-top"
                alt="..."
              />
              <div class="card-body card-body-custom">
                <h6>
                  <u>Lihat Nilai</u>
                </h6>
              </div>
            </div>
          </b-link>
        </div>
      </div>
    </div>
  </Layout>
</template>
